module.exports = __webpack_public_path__ + "img/TL.876b66fa.svg";